import { useEffect, useCallback } from "react";
import { flushSync } from "react-dom";
import { UseFormReturnType } from "@mantine/form";
import { useFormContext } from "@/contexts/FormContext";

export function useFormDirtyTracking<T>(form: UseFormReturnType<T>) {
  const { setIsDirty, resetDirty } = useFormContext();

  useEffect(() => {
    const isDirty = form.isDirty();
    setIsDirty(isDirty);
  }, [form.values, setIsDirty, form]);

  useEffect(() => {
    return () => {
      setIsDirty(false);
    };
  }, [setIsDirty]);

  const handleSuccessfulSubmit = useCallback(() => {
    form.resetDirty();
    flushSync(() => {
      resetDirty();
    });
  }, [form, resetDirty]);

  return { resetFormDirty: handleSuccessfulSubmit };
}
